import React, {Fragment, ReactElement} from 'react';
import Button from '@cmsgov/design-system-core/dist/components/Button/Button';
import { FormattedMessage } from 'react-intl/dist';

// Components

import ModalHeader from '../../../components/common/headers/ModalHeader';

// Constants

import { configs } from '../../../constants/configs/configs';

// Types

import { CommonModalProps } from '../SsapTypes';
import { History } from 'history';

interface UndoMemberRemovalModal extends CommonModalProps {
    modal: {
        modalData: {
            history: History
        }
    }
}

const UndoMemberRemovalModal = (props: UndoMemberRemovalModal): ReactElement => {

    const {
        actions: {
            hideModal
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        modal: {
            modalData: {
                history: {
                    push
                }
            }
        },
        modalHeaderProps
    } = props;

    const handleGoToDashboardClick = (): void => {
        hideModal();
        push(configs.routes.INDPORTAL);
    };

    return (
        <Fragment>
            <div className = 'gi-modal__header__head' >
                <ModalHeader { ...modalHeaderProps } />
            </div>
            <div id = 'undoMemberRemovalModal' className = 'gi-modal__body' >
                <FormattedMessage id = 'modals.undo_member_removal.content' />
            </div>
            <div className = 'gi-modal__footer' >
                <div className = 'grid-row controls' >
                    <div className = 'grid-offset-4 txt-left' >
                        <Button
                            className = 'usa-button usa-button--outline gi-button gi-button__outline'
                            onClick = { hideModal }
                        >
                            <FormattedMessage id = 'button.close' />
                        </Button>
                        <Button
                            className = 'usa-button gi-button gi-button__primary'
                            onClick = { handleGoToDashboardClick }
                            inputRef = { boundAnchor(anchor_1) }
                        >
                            <FormattedMessage id = 'button.go_to_dashboard_ssap' />
                        </Button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default UndoMemberRemovalModal;